__turbopack_context__.v({
  "cta": "jVhVNG_cta",
  "ctas": "jVhVNG_ctas",
  "sub": "jVhVNG_sub",
  "text": "jVhVNG_text",
  "title": "jVhVNG_title",
  "titleHighlight": "jVhVNG_titleHighlight",
  "welcome": "jVhVNG_welcome",
});
